import BaseApi from '../base';

class QuestionnaireApi extends BaseApi {
  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async getQuestionnaires(token) {
    return this.makeRequest(this.METHOD_GET, 'questionnaires', token);
  }

  /**
   * @param {string} token
   * @param {string} userId
   * @returns {Promise<*>}
   */
  async getUserAnswers(token, userId) {
    return this.makeRequest(this.METHOD_GET, `answers?user=${userId}`, token);
  }

  /**
   * @param {string} token
   * @param {string} answer
   * @param {string} comment
   * @returns {Promise<*>}
   */
  async addAnswerComment(token, answer, comment) {
    return this.makeRequest(this.METHOD_POST, 'answers/comment', token, { answer, comment });
  }

  /**
   * @param {string} token
   * @param {string} id
   * @param data
   * @returns {Promise<*>}
   */
  async updateAnswers(token, data) {
    return this.makeRequest(this.METHOD_POST, 'answers', token, data);
  }
}

export default QuestionnaireApi;
